import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, Brush,
} from "recharts";

const NpsOverTimeScoreChart = ({ data, smoothLine }) => {
    const rawMin = Math.min(...data.map((item) => item.nps_score));
    const rawMax = Math.max(...data.map((item) => item.nps_score));
    const minScore = Math.floor(rawMin );
    const maxScore = Math.ceil(rawMax );

    return (
        <ResponsiveContainer width="100%" height={'100%'}>
            <LineChart
                data={data}
                margin={{
                    top: 20,
                    right: 20,
                    bottom: 20,
                    left: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis
                    dataKey="label"
                    tick={{ fontSize: 14, fill: "#333", fontWeight: "500" }}

                />
                <YAxis
                    tick={{ fontSize: 14, fill: "#333" }}
                    domain={[minScore, maxScore]}
                />
                <Tooltip
                    contentStyle={{ backgroundColor: "#f5f5f5", borderRadius: "10px" }}
                    labelStyle={{ fontWeight: "bold" }}
                    formatter={(value) => value}
                />
                <Legend
                    wrapperStyle={{ bottom: 25 }}
                    align="center"
                    verticalAlign="bottom"
                    iconType="circle"
                />
                <Line
                    type={smoothLine ? "monotone" : "linear"}
                    dataKey="nps_score"
                    name="NPS Score"
                    stroke="#8884d8"
                    strokeWidth={3}
                    dot={ false }
                    activeDot={{ r: 8, stroke: "#8884d8", strokeWidth: 2 }}
                />
                <Brush
                    dataKey="date"
                    height={30}
                    stroke="#696969"
                    travellerWidth={12}
                    gap={2}
                    startIndex={0}
                    endIndex={data.length - 1}
                    fill="#D3D3D3"
                    travellerStyle={{
                        stroke: "#696969",
                        fill: "#A9A9A9",
                        cursor: "pointer",
                    }}
                    selectedBoxStyle={{
                        stroke: "#A9A9A9",
                        fill: "rgba(169, 169, 169, 0.2)",
                        cursor: "move",
                    }}
                    padding={{ top: 2, bottom: 2 }}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default NpsOverTimeScoreChart;
